/**
 * Static per-tenant configuration (one JSON file per tenant, same shape as the
 * platform's tenant config): which content modules are enabled and what each
 * is called. To add a tenant, drop `<tenant>.json` here and add one line below.
 *
 * Only `modules.<key>.enabled` and `modules.<key>.names` are read; see
 * shared/tenantConfig.js for how platform module keys map to dashboard tabs.
 */

import clirnet from "./clirnet.json" with { type: "json" };
import dentalnet from "./dentalnet.json" with { type: "json" };
import docflix from "./docflix.json" with { type: "json" };
import vetnet from "./vetnet.json" with { type: "json" };

export const TENANT_CONFIGS = { clirnet, dentalnet, docflix, vetnet };
